"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByProperty = void 0;
function sortByProperty(property) {
    let sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return (previous, next) => {
        let result = 0;
        if (previous[property] < next[property]) {
            result = -1;
        }
        else if (previous[property] > next[property]) {
            result = 1;
        }
        else {
            result = 0;
        }
        return result * sortOrder;
    };
}
exports.sortByProperty = sortByProperty;
